import React from 'react';
import { inject, observer } from 'mobx-react';
import { AppLocaleProvider, Row, Col } from 'sd-ui-components';
import ScorePercentage from '../Common/ScorePercentage.jsx';

const { FormattedMessage, injectIntl } = AppLocaleProvider;

@inject('ObservationsStore')
@observer
class EventHeader extends React.Component {
  render() {
    return (
      <div className="event-header">
        <Row gutter={16}>
          <Col span={18}>
            <h2 className="events-observation-name">
              {this.props.ObservationsStore.selectedObservation.observationName}
            </h2>
          </Col>
          <Col span={4} push={2} className="events-score-column">
            <div className="events-score-percent-circle-div sd-primary-color-4-background">
              <h2 className="events-score-percent-number">
                <ScorePercentage
                  value={
                    this.props.ObservationsStore.selectedObservation
                      .scorePercentage
                  }
                  wholeNumber={true}
                />
              </h2>
            </div>
          </Col>
        </Row>
        <Row>
          <Col span={18}>
            <span>
              <FormattedMessage
                id="App.EventDetails.ScorePercentageInformation"
                defaultMessage="Examples from this past week that contributed to your safety score by {scorePercentage}"
                values={{
                  scorePercentage: (
                    <ScorePercentage
                      value={
                        this.props.ObservationsStore.selectedObservation
                          .scorePercentage
                      }
                      wholeNumber={true}
                    />
                  )
                }}
              />
            </span>
          </Col>
        </Row>
      </div>
    );
  }
}

export default injectIntl(EventHeader);



// WEBPACK FOOTER //
// ./src/containers/Events/EventHeader.jsx